import { Stars } from '@mui/icons-material';
import { Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

const PREFIX = 'Request';

const classes = {
  container: `${PREFIX}-container`,
  icon: `${PREFIX}-icon`,
  text: `${PREFIX}-text`,
};

const StyledAlert = styled(Alert)(({ theme }) => ({
  [`&.${classes.container}`]: {
    padding: `0px ${theme.spacing(1)} 0px ${theme.spacing(1)}`,
    marginBottom: theme.spacing(1),
    alignItems: 'center',
  },

  [`& .${classes.icon}`]: {
    width: '24px',
    height: '24px',
    fontSize: '30px',
  },
  [`& .${classes.text}`]: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '35rem',
    },
  },
}));

const Request = ({ text }) => {
  return (
    <StyledAlert
      icon={<Stars className={classes.icon} />}
      severity="info"
      className={classes.container}
    >
      <Typography variant="body2" className={classes.text}>
        {text}
      </Typography>
    </StyledAlert>
  );
};

Request.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Request;
